import { datadogLogs } from "@datadog/browser-logs";
import { DataDogErrorName } from "src/enums";
import { HTTP_CODE_UNAUTHORIZED } from "src/features/signin/exports/types";
import { isApiError } from "src/features/signin/exports/utils";
import { enhancedFetch } from "src/features/signin/imports/api";
import { ServerErrorActionType } from "src/features/signin/imports/enums";
import { getProxycadorHost } from "src/features/signin/imports/environment";
import { getHasSessionCookies } from "src/features/signin/utils/sessionCookie";
import logger from "utils/logger";

export const fetchAllowedCredentialTypes = () =>
  enhancedFetch(
    `${getProxycadorHost()}/proxycador/api/login/v1/allowedCredentialTypes`
  ).then((resp) => resp.json());

export const fetchSessionDetails = () =>
  enhancedFetch(
    `${getProxycadorHost()}/session-service/v1/secure/session-details`,
    {
      method: "GET",
      headers: {
        "content-type": "application/json",
        accept: "application/json",
      },
    }
  ).then((resp) => resp.json());

export const refreshSessionToken = () =>
  enhancedFetch(
    `${getProxycadorHost()}/proxycador/api/session/refresh`,
    {
      method: "POST",
      headers: {
        "content-type": "application/json",
        accept: "application/json",
      },
    },
    { type: ServerErrorActionType.LOGOUT }
  );

export const ensureHasSessionCookies = () => {
  const hasSessionCookies = getHasSessionCookies();

  if (hasSessionCookies) {
    return Promise.resolve();
  }

  return enhancedFetch(
    `${getProxycadorHost()}/proxycador/api/session/refresh`,
    {
      method: "POST",
      credentials: "include",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
    }
  )
    .then((resp) => resp.json())
    .catch((err) => {
      datadogLogs.logger.error(DataDogErrorName.SESSION_TOKEN_REFRESH, {}, err);

      if (isApiError(err) && err.status === HTTP_CODE_UNAUTHORIZED) {
        logger.error("Unauthorized session token", err);
      }
    });
};

export const registerVisitor = ({ body, provider }) =>
  enhancedFetch(
    `${getProxycadorHost()}/proxycador/api/visitors/register/v1/${provider}`,
    {
      method: "POST",
      headers: {
        "content-type": "application/json",
        accept: "application/json",
      },
      body: JSON.stringify(body),
    }
  ).then((resp) => resp.json());

export const registerVisitorWithRecaptcha = ({
  body,
  provider,
  recaptchaToken,
}) =>
  enhancedFetch(
    `${getProxycadorHost()}/proxycador/api/visitors/register/v1/${provider}`,
    {
      method: "POST",
      headers: {
        "content-type": "application/json",
        accept: "application/json",
        "x-recaptcha-token": recaptchaToken,
      },
      body: JSON.stringify(body),
    }
  ).then((resp) => resp.json());

export const performGoogleOneTapSignIn = (body) =>
  enhancedFetch(`${getProxycadorHost()}/google-login/id-token/v1/login`, {
    method: "POST",
    headers: {
      "content-type": "application/json",
      accept: "application/json",
    },
    body: JSON.stringify(body),
  }).then((resp) => resp.json());
